import { TrashIcon } from '@heroicons/react/24/outline';

import ConfirmationModal from '@/dialogs/confirmation-modals/ConfirmationModal';
import { useTranslation } from '@/hooks/useTranslation';

interface DiscardChangesConfirmationModalProps {
    title?:string,
    onDiscard: () => void;
    show: boolean;
    onClose: () => void;
}

export const DiscardChangesConfirmationModal = ({
    title,
    onDiscard,
    show,
    onClose
}: DiscardChangesConfirmationModalProps) => {
    const { t } = useTranslation();

    const handleDiscardChanges = () => {
        onDiscard();
    };

    return (
        <ConfirmationModal
            title={title || t('MODAL.DISCARD_CHANGES_TITLE')}
            subTitle={t('MODAL.DISCARD_CHANGES_SUBTITLE')}
            discardBtnText={t('ACTION.DISCARD')}
            closeBtnText={t('CANCEL')}
            iconVariant='destructive'
            btnVariant='destructive'
            show={show}
            icon={TrashIcon}
            onSubmit={handleDiscardChanges}
            onClose={onClose}
        />
    );
};
